import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { en } from './en'
import { es } from './es'
import { compareKeys } from './parity'

export const SUPPORTED_LANGUAGES = ['en', 'es'] as const
export type Language = (typeof SUPPORTED_LANGUAGES)[number]

/**
 * Resolution chain (Rule 18): tenant override → base[lang] → base[en] → call-site default → key.
 * Tenant overrides are [Open]: they will be loaded with `i18n.addResourceBundle(lang, 'tenant', …)`
 * and placed first in `ns` once the API exposes them.
 */
function detectLanguage(): Language {
  const nav = typeof navigator !== 'undefined' ? navigator.language.slice(0, 2) : 'en'
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(nav) ? (nav as Language) : 'en'
}

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, es: { translation: es } },
  lng: detectLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false }, // React escapes output
  returnNull: false,
})

if (import.meta.env.DEV) {
  const { missingInA, missingInB } = compareKeys(en, es)
  if (missingInA.length || missingInB.length) {
    console.error('[i18n] key parity broken', { missingInEs: missingInB, missingInEn: missingInA })
  }
}

export default i18n
